import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" };
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" };
const _hoisted_3 = { class: "d-sm-flex align-items-center" };
const _hoisted_4 = { class: "d-flex align-items-center" };
const _hoisted_5 = ["placeholder"];
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" };
const _hoisted_7 = { class: "table-responsive" };
const _hoisted_8 = { class: "table text-nowrap align-middle mb-0" };
const _hoisted_9 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
};
const _hoisted_10 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_11 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_12 = {
    scope: "col",
    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
};
const _hoisted_13 = { key: 0 };
const _hoisted_14 = {
    colspan: "4",
    class: "text-center py-4"
};
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0 text-capitalize" };
const _hoisted_16 = { class: "d-flex align-items-center text-capitalize" };
const _hoisted_17 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" };
const _hoisted_18 = ["onClick"];
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-muted" };
const _hoisted_21 = { class: "form-check form-switch" };
const _hoisted_22 = ["checked", "onChange"];
const _hoisted_23 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" };
const _hoisted_24 = { class: "d-flex align-items-center gap-1" };
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" };
const _hoisted_26 = { class: "dropdown" };
const _hoisted_27 = { class: "dropdown-menu" };
const _hoisted_28 = ["onClick"];
const _hoisted_29 = ["onClick"];
const _hoisted_30 = ["onClick"];
const _hoisted_31 = { key: 2 };
const _hoisted_32 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" };
const _hoisted_33 = { class: "mb-0 text-paragraph" };
const _hoisted_34 = { class: "mt-15 mt-md-0" };
const _hoisted_35 = { class: "pagination mb-0" };
const _hoisted_36 = ["onClick"];
const _hoisted_37 = {
    class: "modal fade",
    id: "confirmModal",
    tabindex: "-1",
    "aria-labelledby": "confirmModalLabel",
    "aria-hidden": "true"
};
const _hoisted_38 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_39 = { class: "modal-content" };
const _hoisted_40 = { class: "modal-header" };
const _hoisted_41 = {
    class: "modal-title",
    id: "confirmModalLabel"
};
const _hoisted_42 = { class: "modal-body text-center" };
const _hoisted_43 = ["innerHTML"];
const _hoisted_44 = { class: "modal-footer" };
const _hoisted_45 = {
    type: "button",
    class: "btn btn-secondary",
    "data-bs-dismiss": "modal"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_EmptyTable = _resolveComponent("EmptyTable");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.gotoCreate && _ctx.gotoCreate(...args))),
                        class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                        type: "button"
                    }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('feature.addFeature')) + " ", 1),
                        _cache[7] || (_cache[7] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("form", {
                        class: "search-box position-relative me-15",
                        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => { }, ["prevent"]))
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchQuery) = $event)),
                            type: "text",
                            class: "form-control shadow-none text-black rounded-0 border-0",
                            placeholder: _ctx.$t('forms.searchFeaturePlaceholder'),
                            onInput: _cache[2] || (_cache[2] = ($event) => (_ctx.currentPage = 1))
                        }, null, 40, _hoisted_5), [
                            [_vModelText, _ctx.searchQuery]
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("button", {
                            type: "submit",
                            class: "bg-transparent text-primary transition p-0 border-0"
                        }, [
                            _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
                        ], -1))
                    ], 32)
                ])
            ]),
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('lists.id')), 1),
                                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('lists.name')), 1),
                                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('lists.availability')), 1),
                                _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('lists.translations')), 1),
                                _cache[9] || (_cache[9] = _createElementVNode("th", {
                                    scope: "col",
                                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                                }, null, -1))
                            ])
                        ]),
                        _createElementVNode("tbody", null, [
                            (_ctx.isLoading)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
                                    _createElementVNode("td", _hoisted_14, [
                                        _createVNode(_component_LoaderComponent)
                                    ])
                                ]))
                                : (!_ctx.isLoading && _ctx.allFeature.length > 0)
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.allFeature, (feature, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                            key: feature.id
                                        }, [
                                            _createElementVNode("th", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "form-check mb-0 text-capitalize" }, [
                                                        _createElementVNode("input", {
                                                            class: "form-check-input shadow-none",
                                                            type: "checkbox"
                                                        })
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_17, [
                                                        _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: ($event) => (_ctx.selectForDetail(feature))
                                                        }, _toDisplayString(index + 1) + " - " + _toDisplayString(_ctx.getShortUuid(feature.id)), 9, _hoisted_18)
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_19, _toDisplayString(feature.name), 1),
                                            _createElementVNode("td", _hoisted_20, [
                                                _createElementVNode("div", _hoisted_21, [
                                                    _createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "checkbox",
                                                        checked: _ctx.getFeatureAvailability(feature),
                                                        onChange: ($event) => (_ctx.toggleFeatureActivation(feature, $event))
                                                    }, null, 40, _hoisted_22)
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_23, [
                                                _createElementVNode("div", _hoisted_24, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLanguages, (lang) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                            key: lang.code,
                                                            class: _normalizeClass(["badge rounded-1 fw-semibold fs-12 p-1 me-1 text-uppercase border",
                                                                _ctx.isTranslated(feature, lang.code)
                                                                    ? 'bg-success text-white border-success'
                                                                    : 'bg-transparent text-muted border-light'
                                                            ]),
                                                            style: { "min-width": "30px", "text-align": "center" }
                                                        }, _toDisplayString(lang.code), 3));
                                                    }), 128))
                                                ])
                                            ]),
                                            _createElementVNode("td", _hoisted_25, [
                                                _createElementVNode("div", _hoisted_26, [
                                                    _cache[14] || (_cache[14] = _createElementVNode("button", {
                                                        class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                                        type: "button",
                                                        "data-bs-toggle": "dropdown",
                                                        "aria-expanded": "false"
                                                    }, [
                                                        _createElementVNode("i", { class: "flaticon-dots" })
                                                    ], -1)),
                                                    _createElementVNode("ul", _hoisted_27, [
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDetail(feature))
                                                            }, [
                                                                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.view')), 1)
                                                            ], 8, _hoisted_28)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDetail(feature))
                                                            }, [
                                                                _cache[12] || (_cache[12] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.edit')), 1)
                                                            ], 8, _hoisted_29)
                                                        ]),
                                                        _createElementVNode("li", null, [
                                                            _createElementVNode("a", {
                                                                class: "dropdown-item d-flex align-items-center",
                                                                "data-bs-toggle": "modal",
                                                                "data-bs-target": "#confirmModal",
                                                                href: "javascript:void(0);",
                                                                onClick: ($event) => (_ctx.selectForDelete(feature))
                                                            }, [
                                                                _cache[13] || (_cache[13] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.delete')), 1)
                                                            ], 8, _hoisted_30)
                                                        ])
                                                    ])
                                                ])
                                            ])
                                        ]));
                                    }), 128))
                                    : (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                                        _createVNode(_component_EmptyTable, {
                                            message: _ctx.$t('feature.noFeatures'),
                                            colspan: 4,
                                            textClass: "text-muted"
                                        }, null, 8, ["message"])
                                    ]))
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.paginationInfo), 1),
                    _createElementVNode("nav", _hoisted_34, [
                        _createElementVNode("ul", _hoisted_35, [
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Previous",
                                    onClick: _cache[4] || (_cache[4] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
                                }, [...(_cache[15] || (_cache[15] = [
                                        _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                                    ]))])
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.generatePageNumbers(), (page) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: page,
                                    class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                                }, [
                                    _createElementVNode("a", {
                                        class: "page-link",
                                        href: "#",
                                        onClick: _withModifiers(($event) => (_ctx.changePage(page)), ["prevent"])
                                    }, _toDisplayString(page), 9, _hoisted_36)
                                ], 2));
                            }), 128)),
                            _createElementVNode("li", {
                                class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                                _createElementVNode("a", {
                                    class: "page-link",
                                    href: "#",
                                    "aria-label": "Next",
                                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
                                }, [...(_cache[16] || (_cache[16] = [
                                        _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                    ]))])
                            ], 2)
                        ])
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("h5", _hoisted_41, _toDisplayString(_ctx.$t('feature.deleteConfirmation')), 1),
                        _cache[17] || (_cache[17] = _createElementVNode("button", {
                            type: "button",
                            class: "btn-close",
                            "data-bs-dismiss": "modal",
                            "aria-label": "Close"
                        }, null, -1))
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                        _cache[18] || (_cache[18] = _createElementVNode("i", { class: "fas fa-exclamation-triangle warning-icon" }, null, -1)),
                        _createElementVNode("p", {
                            class: "mb-0",
                            innerHTML: _ctx.$t('feature.deleteConfirmationText')
                        }, null, 8, _hoisted_43)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("button", _hoisted_45, [
                            _cache[19] || (_cache[19] = _createElementVNode("i", { class: "fas fa-times me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-danger",
                            onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.confirmationDeleteAction(_ctx.featureSelected))),
                            "data-bs-dismiss": "modal"
                        }, [
                            _cache[20] || (_cache[20] = _createElementVNode("i", { class: "fas fa-trash-alt me-2" }, null, -1)),
                            _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                        ])
                    ])
                ])
            ])
        ])
    ], 64));
}
